export const SET_LOGGED_IN = 'SET_LOGGED_IN'
export const LOGOUT_USER = 'LOGOUT_USER'
export const UPDATE_PROFILE_PIC_URL = 'UPDATE_PROFILE_PIC_URL'
export const UPDATE_HELP_PAGES_VIEWED = 'UPDATE_HELP_PAGES_VIEWED'
export const UPDATE_USER_SESSION = 'UPDATE_USER_SESSION'
export const SET_USER_DATA = 'SET_USER_DATA'
export const SET_ACCOUNT_DATA = 'SET_ACCOUNT_DATA'
export const SET_LOGIN_DATA = 'SET_LOGIN_DATA'
